export default "__VITE_ASSET__BRe6849S__"